<template lang="">
    <div id="retours">



      <v-row no-gutters>

      <v-col cols="12" lg="12" xl="12">
        <v-toolbar color="#55ABCF" flat dense>
          <v-col
            cols="6"
            lg="6"
            xl="2"
            class="pa-0 font_color text-left"
          >
            HISTORIQUE DES RETOURS
          </v-col>

        </v-toolbar>
      </v-col>
      
      </v-row>
      
                    <Popup :dialog="dialogDelete" text="Supprimer ce retour ?" actions="" heightProp="" widthProp="" showClose="false"> 
                <v-card-actions class="mb-10">
                  <v-btn class="actions" color="#0B87BA" width="100px"  large dark rounded @click="deleteItemConfirm">Oui</v-btn>
                  <v-btn class="actions mr-10" color="#0B87BA" width="100px"  large dark rounded @click="dialogDelete = false">Non</v-btn>
                </v-card-actions> 
              </Popup>
      <v-row align="center">
        <v-col cols="12" lg="12" xl="12">
          <resultList
            @emitDialogRetour="dialogDelete = true, id_retour = $event"
            :header="header"
            :items="retours"
            :nbResult=displayItem
            :type="'contact'"
            @sort="sort"
            :totalItems="totalItems"
            :page="page"
            id="encours"
            :canModif="canModif"
            :closed="closed"
            
          />
        </v-col>
        <v-col v-if="nbPage>0" cols="12" lg="12" xl="10">
          <div class="text-center">
            <v-pagination
              v-if="nbPage > 1"
              v-model="page"
              :length="nbPage"
              circle
            ></v-pagination>
          </div>

        </v-col>  
      </v-row>


     <!-- <Popup :dialog="dialog" :text="messageDelete" :actions="actions" @delete="deleteContact" @nothing="dialog=false" /> -->
    </div>
</template>
<script>
import Popup from "@/components/shared/Popup";
import ResultList from "@/components/shared/ResultList";
import api from "@/api/entreprise";
import apiRetour from "@/api/retours";

// import Popup from "@/components/shared/Popup";

export default {
  components: { ResultList, Popup },
  data() {
    return {
      id: this.$route.params.id_entreprise,
      displayItem: process.env.VUE_APP_NB_DISPLAY,
      retours: [],
      dialogDelete: false,
      page: 1,
      column: "creation_date",
      order: "DESC",
      query: "",
      nbPage: 0,
      totalItems: 0,
      usersEntreprise:[],
      canModif:0,
      closed: true,
      //   dialog: false,
      //   messageDelete: "Souhaitez vous supprimer ce contact ?",
      actions: {
        // route: [
        //   {
        //     btn: "OUI",
        //     routeName: "client",
        //     params: { id_entreprise: this.$route.params.id_entreprise },
        //   },
        //   {
        //     btn: "NON",
        //     routeName: "client",
        //     params: { id_entreprise: this.$route.params.id_entreprise },
        //   },
        // ],
        // actions: [
        //   {
        //     btn: "OUI",
        //     event: "delete",
        //   },
        //   {
        //     btn: "NON",
        //     event: "nothing",
        //   },
        // ],
      },
      // Mêmes colonnes que la page « Retours en cours » (RetoursEnCours.vue),
      // sans la colonne CLIENT qui répéterait la même entreprise sur chaque ligne.
      header: [
        { text: "DATE DE CREATION",          align: "center", sortable: true,  value: "creation_date", name: "creation_date" },
        { text: "N° RETOUR",                 align: "center", sortable: false, value: "numero_retour", name: "numero_retour" },
        { text: "MAIL DU CLIENT",            align: "center", sortable: false, value: "email_client", name: "email_client" },
        { text: "VALIDATION",                align: "center", sortable: false, value: "validation_commercial", name: "validation_commercial" },
        { text: "DATE D'ENVOI AU PLUS TARD", align: "center", sortable: false, value: "date_envoi_limite", name: "date_envoi_limite" },
        { text: "CODES PRODUITS",            align: "center", sortable: false, value: "references", name: "references" },
        { text: "TYPE",                      align: "center", sortable: false, value: "type_retour", name: "type_retour" },
        { text: "ACTIONS",                   align: "center", sortable: false, value: "actions_retour", name: "actions_retour" },
      ],
    };
  },
  methods: {
    getRetourEntreprise(query, id_client, page, column, order) {
      api
        .getEntrepriseRetoursClosed(query, id_client, page, column, order)
        .then((res) => {
          res.data.retours.rows.forEach(retour => {
              retour['type_retour'] = retour.TypeRetour.type_retour
              retour['references'] = (retour.articles || []).map(a => a.reference)
          });
            this.retours = res.data.retours.rows;
            this.nbPage = res.data.retours.totalPages;
            this.totalItems = res.data.retours.totalItems;
             if(this.usersEntreprise.length == 0  ){
            res.data.entreprise.Users.forEach(user => {
              this.usersEntreprise.push(user.id_utilisateur)
            })
              this.CanModified()
          }
        }).catch(() => {
          this.$store.dispatch('notify', { message: 'Erreur lors du chargement' });
        });
    },
    sort($event) {
      if ($event.column != undefined) {
        this.column = $event.column;
      }
      if ($event.order != undefined) {
        this.order = $event.order ? "ASC" : "DESC";
      }
      this.page = $event.page;
      this.getRetourEntreprise(
        this.query,
        this.id,
        this.page - 1,
        this.column,
        this.order
      );
    },
    deleteContact() {
      api.archivePersonne(this.idDeleteContact).then((res) => {
        if (res.status == 200) {
          this.dialog = false;
          this.getRetourEntreprise(
            this.query,
            this.id,
            this.page - 1,
            this.column,
            this.order
          );
        }
      }).catch(() => {
        this.$store.dispatch('notify', { message: 'Erreur lors de la suppression' });
      });
    },
    CanModified(){
      if(
      // #1124 : retours en écriture (administrateurs et profil Retours)
      this.$peut('retours', 'ecriture', this.$estAffecte(this.usersEntreprise)) )
      {
        this.canModif = 1
      }
    },
        deleteItemConfirm() {
      apiRetour.deleteRetour(this.id_retour).then(() => {
          this.getRetourEntreprise(
            this.query,
            this.id,
            this.page - 1,
            this.column,
            this.order
          );
        this.dialogDelete = false
      }).catch(() => {
        this.$store.dispatch('notify', { message: 'Erreur lors de la suppression' });
      });
    }
  },
  created() {
    this.getRetourEntreprise(
      this.query,
      this.id,
      this.page - 1,
      this.column,
      this.order
    );
  },
};
</script>
<style lang="scss" scoped>
.btnBold {
  font-weight: bold;
}

.font_color {
  font-weight: bold;
  color: #ffffff;
  text-decoration: none;
}
</style>